export default "__VITE_ASSET__CmUmidS5__"